// import { icons } from '@react-icons/all-files'
import React, { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { ShimmerThumbnail } from "react-shimmer-effects";
import axios from "../../API/axios";
import { getOwnCompaniesList, getUserConfig } from "../../Services/apiService";
import { people, icons, post } from "../../config/imagesLink";
import CreateCompany from "../CreateCompany/CreateCompany";
import UpdateCompany from "../CreateCompany/UpdateCompany";
import AddSharpIcon from '@mui/icons-material/AddSharp';

import CompanyActions from "./CompanyActions";
import { ShimmerDiv } from "@skeleton";
import ErrorToast from "../ErrorToast";
import WarningToast from "../WarningToast";
import SuccessToast from "../SuccessToast";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import useNewsFeedStore from "../NewsFeed/useNewsFeedStore";
import { useTranslation } from "react-i18next";
// import { Link } from 'react-router-dom';
const MyCompanies = ({ GetOwnCompniesListsData, setUpdateList ,hasCcv}) => {
  const userUid = localStorage.getItem("userUid");
  const sessionId = localStorage.getItem("sessionId");
  const ProfilePercent = localStorage.getItem("ProfilePercentage"); 
// console.log("profileConfig", profileConfig, hasCcv);
 const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const openModal = () => {
    setShowModal(true);
  };
  const closeModal = () => {
    setShowModal(false);
  };

 
  //************************Company list Start  ************************//
  const [isLoading, setIsLoading] = useState(true);
  const [companyList, setcompanyList] = useState([]);
  const [companyListError, setCompanyListError] = useState(false);

  const getActiveCompanies = (data) => {
    const list = Array.isArray(data) ? data : [];
    return list.filter((item) => item?.isDeleted !== true);
  };

  const handleCompanyDeleted = (deletedCompUid) => {
    setcompanyList((prev) => {
      const next = getActiveCompanies(
        prev.filter((company) => company.compUid !== deletedCompUid)
      );
      localStorage.setItem("OwncompanyList", JSON.stringify(next));
      setCompanyListError(next.length === 0);
      return next;
    });
    setUpdateList?.((prev) => !prev);
  };

  // const [tableUpadate, setTableUpdate] = useState('')
  
  const getCompanyList = async ({ showLoading = true, forceRefresh = false } = {}) => {
    if (showLoading) {
      setIsLoading(true);
      setCompanyListError(false);
    }
    try {
      const responseData = await getOwnCompaniesList({ forceRefresh });
      const res = getActiveCompanies(responseData);
      localStorage.setItem("OwncompanyList", JSON.stringify(res));
      setcompanyList(res);
      setCompanyListError(res.length === 0);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setcompanyList([]);
      setCompanyListError(true);
      setIsLoading(false);
    }
  }; 
 const [deleteModal, setDeleteModal] = useState(null);
  const openDeleteModal = (compUid) => {setDeleteModal(compUid);}
  const closeDeleteModal = () => {setDeleteModal(null);}

  const [showUpdateModal, setShowUpdateModal] = useState(null); 
    const handleOpenUpdate = (compUid) =>{   
      setShowUpdateModal(compUid)
    } ;
    const handleClose = () => setShowUpdateModal(null);
  const language = localStorage.getItem("Lang");
  const [profileConfig, setProfileConfig] = useState("");

   const userConfig = async () => {
      try {
        const Response = await getUserConfig();
        setProfileConfig(Response);

        if (Response?.hasDob === false || Response?.hasGender === false || Response?.hasCity === false) {
          // setShowUserAuthModal(true);
          // document.body.classList.add('modal-open');
          // fetchData();

        }
      } catch (error) {
        if (
          (error.code === "ERR_NETWORK" && sessionId) ||
          (error.code === "ERR_BAD_REQUEST" && sessionId)
        ) {
          setUnauthorisedModal(true);
        }
      }
    };
  //************************Company list End  ************************//

  const navigate = useNavigate();
  const [unauthorisedModal, setUnauthorisedModal] = useState(false);
  
   useEffect(() => {
        const sessionId = localStorage.getItem("sessionId");
        if (sessionId) {
          (async () => { 
            await Promise.all([  
                userConfig(),
                getCompanyList(), 
            ]);
          })();
        } 
      }, []);

  const [userCcv, setUserCcv] = useState("");
  const AddUserCcv = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
            langKey: language === "en" ? "" : language,
    };
    try {
      await axios.post(`Ccv/AddUserCcv`, data).then((resData) => {
        // console.log('resData', resData.data.responseData);
        setUserCcv(resData.data.responseData);
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  const [showResumeModal, setShowResumeModal] = useState(false);

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  
         // -------------------------------------------------------------------------
      const { setIsNewsPageLoaded } = useNewsFeedStore();
  
      useEffect(() => {
          setIsNewsPageLoaded(true); // enable right panel when entering NewsFeed
  
          return () => setIsNewsPageLoaded(false); // optional cleanup when leaving
      }, [setIsNewsPageLoaded]);
  
      // -------------------------------------------------------------------------
  
  return (
    <>
      <div className="friend-main-container mt-3">
        <Row className="mt-3 manageCompniesMain">
          {/* <div className="headerSection  d-block d-md-flex justify-content-between"> */}
          <Col md={7}>
            <div className="manageCompnies">
              <h1 className="f-16 fw-bold"> {t("Manage Companies.Manage Companies")} </h1>
            </div>
          </Col>
          <Col md={5} className="d-flex justify-content-end compnies-create-btn">

            <button
              type="button"
              className="mainBtn1 createCompBtn d-flex align-items-center"
              onClick={(e) => {
                e.preventDefault();
                (profileConfig.hasCcv === null || profileConfig.hasCcv === false) &&
                  ProfilePercent < 60
                  ? setShowResumeModal(!showResumeModal)
                  : openModal()
              }}
            >
               {t("Manage Companies.Create Company")}
            </button>
          </Col>
          {/* </div> */}
        </Row>
        <div className="frindsCardContainer">
          <Row>
            {isLoading ? (
              <div className="mt-3">
                {/* <ShimmerThumbnail height={250} rounded /> */}
                <ShimmerDiv height={250} width={'100%'} />
              </div>
            ) : (
              companyListError || companyList.length === 0 ? (
                <Col xs={12} className="mt-2 error-image-cont error-cont d-flex justify-content-center">
                  <img src={post.errorSmall} alt="404 Not Found" width={200} height={200} />
                </Col>
              ) :
                companyList &&
                companyList.map((item, index) => {
                  console.log("own company", item);
                  return (
                    <Col md={6} sm={12} key={index} className="compnies-card">
                      <div className="PeopleCard" style={{height:"175px"}}>
                        <div className="PeopleCardHeader">
                          <img
                            src={item?.backGroundImage}
                            alt=""
                            width="100%"
                            height="120px"
                          />
                          <div className="overlay"></div>
                          <div className="centerAlignment">
                            <Link to={`/Company/${item.compUid}/${item.slug}`}>
                              <div className="">
                                <img
                                  src={
                                    item.logoImage === null
                                      ? people.DefaultProfile
                                      : item.logoImage
                                  }
                                  alt=""
                                  srcset=""
                                  style={{ borderRadius: "50px" }}
                                  width={50}
                                  height={50}
                                />
                              </div>
                            </Link>
                            <div className=" d-block d-md-flex align-items-baseline justify-content-between">
                              <div className=" ">
                                <div className="mainCardText mb-0">
                                  <Link to={`/Company/${item.compUid}/${item.slug}`}>
                                    <h1>{item.compName}</h1>
                                  </Link>
                                </div>

                                <div className="mainCardTex mb-0">
                                    {item.isDeleted === true ? ( 
                                      <div className="mainCardText1 badgeContainer">
                                        <div className="rejecte ms-2">
                                          <h1 className="text-red">{t("Drafts.Delete")}</h1>
                                        </div>
                                    </div>
                                    ): ""}
                                  </div>

                                <div className="mainCardText">
                                  <h1>{item.nameTag}</h1>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="PeopleCardContainer p-2 ms-3  d-flex align-items-baseline justify-content-between">
                          <div>
                            <div className="mainCardText"></div>

                            <div className="cardSubText">
                              <h1>{item.industryName}</h1>
                            </div>
                          </div>
                          <div
                            className="follower-button d-flex flex-column align-items-end"
                            style={{ width: "100px" }}
                          >
                            {/* <CompanyActions compUid={item.compUid} getCompanyList={getCompanyList} item={item} /> */}
                            
                            <CompanyActions 
                            showUpdateModal={showUpdateModal} 
                            handleClose={handleClose} 
                            handleOpenUpdate={handleOpenUpdate}
                            // setShowUpdateModal={setShowUpdateModal} 
                            compUid={item.compUid} 
                            getCompanyList={getCompanyList}
                            onCompanyDeleted={handleCompanyDeleted}
                            item={item}
                            // setDeleteModal={setDeleteModal}
                            openDeleteModal={openDeleteModal}
                            closeDeleteModal={closeDeleteModal}
                            deleteModal={deleteModal} 
                            // companyDetails={companyDetails}
                            // onClick={() => setCompUid(item.compUid)}
                            />
                            {item.follwersCounts >= 10 ?(
                            <div className="cardSubText mt-2">
                              <h1>{item.follwersCounts} {t("My Connection.Followers")}</h1>
                            </div>
                            ): ""}
                          </div>
                        </div>
                      </div>
                    </Col>
                  );
                })
            )}
          </Row>
        </div>
      </div>
      {showModal && (
        <CreateCompany
          openModal={openModal}
          showModal={showModal}
          closeModal={closeModal}
          getCompanyList={getCompanyList}
          // GetOwnCompniesListsData={getCompanyList}
          setUpdateList={setUpdateList}
        />
      )}

      {showResumeModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("modals.Please complete your profile up to 60% and must have valid resume to  Create Company")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    setShowResumeModal(false);
                  }}
                />
              </div>
              <div className="text-center mt-2">
                <Link to={`/User/${userUid}`}>
                  <button
                    color=""
                    className="closebtn"
                    style={{ width: "150px" }}
                  // onClick={() => {
                  //   userCcv !== "True" && AddUserCcv();
                  // }}
                     >
                    {t("Newsfeed.Manage Profile")}
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
      {unauthorisedModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="d-flex justify-content-between align-items-center p-2">
                <div>
                  <h4 className="text-center AdBlocker">{t("Recommendations.Warning")}</h4>
                  <p className="text-center ad-p">
                    {t("modals.Your session has expired or you are not authorized to access this resource. Please log in again to continue.")} 
                  </p>
                  <div className="text-center m-auto mt-3">
                    <button
                      type="button"
                      className="mainBtn1 "
                      onClick={() => {
                        setUnauthorisedModal(!unauthorisedModal)
                        navigate("/SignIn");
                        localStorage.clear();
                        sessionStorage.removeItem('hasModalShown');
                      }}
                    >
                      {t("modals.login")} 
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MyCompanies;
